// extracted by mini-css-extract-plugin
export default {"dropdownFooter":"RejectApplicationModal-index__dropdownFooter--zGtP0","manageLink":"RejectApplicationModal-index__manageLink--C5LVc"};